<app-header [hideBackButton]="false"></app-header>
<ion-content>
  <ion-list
    data-cy="more-actions-list"
    class="list-more-mobile"
    lines="none"
    *ngIf="(moreVM$ | async) as vm"
  >
    <div class="group">
      <ion-item
        class="btm-line"
        data-cy="more-options-my-orders-link"
        (click)="routeTo(['my-orders-view'])"
      >
        <ion-label>{{ 'i18n.moxe-links.myOrders' | translate }}</ion-label>
      </ion-item>
      <ion-item
        *ngIf="!vm?.isSuperUser"
        class="btm-line"
        data-cy=""
        (click)="routeTo(['my-orders'])"
      >
        <ion-label>{{ 'i18n.moxe-links.orderStatus' | translate }}</ion-label>
      </ion-item>
      <ng-container>
        <ion-item
          *ngIf="!vm?.isSuperUser && !hideImportOptions"
          class="btm-line"
          data-cy="more-options-import-order-modal-link"
          (click)="openImportOrderModal(true)"
        >
          <ion-label>{{'i18n.moxe-links.importOrder'| translate}}</ion-label>
        </ion-item>
      </ng-container>
      <ng-container>
        <ion-item
          *ngIf="!vm?.isSuperUser && !hideImportOptions"
          class="btm-line"
          data-cy="more-option-imported-orders-link"
          (click)="routeToImportedOrders()"
        >
          <ion-label
            >{{ 'i18n.moxe-links.importedOrders' | translate }}</ion-label
          >
        </ion-item>
      </ng-container>
      <ion-item
        class="btm-line"
        data-cy="more-option-quick-order-entry-link"
        (click)="routeToQuickOrderEntry()"
      >
        <ion-label
          >{{ 'i18n.moxe-links.quickOrderEntry' | translate }}</ion-label
        >
      </ion-item>
      <ion-item
        *appShowSplit="[imageOrderingFeatureFlag]"
        class="btm-line"
        data-cy="more-option-image-order-link"
        (click)="routeToImageOrderingEntry()"
      >
        <ion-label>{{ 'i18n.moxe-links.imageOrdering' | translate }}</ion-label>
      </ion-item>
    </div>
  </ion-list>
  <ion-modal
    class="ion-modal-touch"
    [initialBreakpoint]="1"
    [breakpoints]="[0, 0.5, 1]"
    [isOpen]="importOrderModalIsOpen$ | async"
    (ionModalDidDismiss)="handleImportModalDismiss($event)"
  >
    <ng-template>
      <app-import-order-modal-mobile
        (isOpenEmitter)="openImportOrderModal($event)"
        (importOrderEmitter)="importOrderHandler($event)"
        (importSuccessEmitter)="handleImportSuccess($event)"
        (initializeImportOrderStateEmitter)="initializeImportOrderState($event)"
        [fileImportErrors$]="fileImportErrors$"
        [loading$]="importOrdersLoading$"
        [loaded$]="importOrdersLoaded$"
        [orderTransactions$]="importOrdersTransactions$"
        [fileImportMessage$]="fileImportMessage$"
        [apiError$]="apiError$"
        class="ion-page"
      ></app-import-order-modal-mobile>
    </ng-template>
  </ion-modal>
</ion-content>
<app-footer></app-footer>
